import { useCallback, useSyncExternalStore } from "react";
import StickerCreateSheet from "@/components/chat/StickerCreateSheet";
import {
  bumpStickerRefresh,
  closeStickerCreate,
  getStickerCreateOverlay,
  subscribeStickerCreateOverlay,
} from "@/lib/sticker-create-overlay";

/**
 * Mounted ONCE near the root so the sticker creator survives any
 * chat-route remount, search-param navigation, or native picker
 * round-trip on mobile.
 */
export default function StickerCreateOverlayHost() {
  const state = useSyncExternalStore(
    subscribeStickerCreateOverlay,
    getStickerCreateOverlay,
    getStickerCreateOverlay,
  );

  const handleOpenChange = useCallback((open: boolean) => {
    if (!open) closeStickerCreate();
  }, []);

  const handleCreated = useCallback(() => {
    bumpStickerRefresh();
  }, []);

  if (!state.open) return null;

  return (
    <StickerCreateSheet
      open={state.open}
      onOpenChange={handleOpenChange}
      onCreated={handleCreated}
    />
  );
}
